export default [
  {
    label: 'Esmeralda',
  },
  {
    label: 'Esmeralda Premium',
  },
  {
    label: 'Batatais',
  },
  {
    label: 'Batatais Plus',
  },
  {
    label: 'São Carlos',
  },
  {
    label: 'São Carlos Plus',
  },
  {
    label: 'Coreana/Japonesa',
  },
  {
    label: 'Bermuda Tifton 419',
  },
  {
    label: 'Bermuda Celebration',
  },
  {
    label: 'Santo Agostinho/Inglesa',
  },
]
